import React from 'react'
import { camelCase } from 'lodash-es'
import { useTranslation } from 'react-i18next'
import { EmbeddedUseCases } from '../helpers/constants'
import { EmbeddedUseCase } from '../helpers/types'
import { IconList } from './IconList'

export interface InfoHeaderProps {
  useCase?: EmbeddedUseCase
}

export const InfoHeader = ({ useCase }: InfoHeaderProps) => {
  const { t } = useTranslation()

  const translationKey = camelCase(useCase || EmbeddedUseCases.BOTH)

  return (
    <>
      <h1 className="text-h1 text-center text-foreground-prominent md:text-left">
        {t(`customerPendingAgreements.header.title.${translationKey}`)}
      </h1>
      <h3 className="text-h3 text-center text-foreground-prominent md:text-left pt-3 md:pt-0">
        {t(`customerPendingAgreements.header.subTitle.${translationKey}`)}
      </h3>
      <IconList
        items={[
          {
            iconName: 'CoinArrowOutCustom',
            text: t(`customerPendingAgreements.header.benefitCoin.${translationKey}`),
          },
          {
            iconName: 'Lightning',
            text: t(`customerPendingAgreements.header.benefitLightning.${translationKey}`),
          },
          {
            iconName: 'Lock',
            text: t(`customerPendingAgreements.header.benefitLock.${translationKey}`),
          },
        ]}
        className="hidden md:flex"
      />
    </>
  )
}
